<template>
  <div class="appointmens content">
    <v-modal v-show="isAppointmentRequest">
      <div slot="body"></div>
    </v-modal>

    <AppointmentsClient
      :key="isArchive ? 'current-appointments' : 'appointments-archive' "
      :appointments="appointments"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import AppointmentService from "@/services/AppointmentService";
import VModal from "@/components/VModal";

import loadingMixin from "../mixins/loadingMixin";
import AppointmentsClient from "../components/AppointmentsClient";


export default {
  name: "Appointments",

  components: {
    AppointmentsClient,
    VModal
  },

  mixins: [loadingMixin],

  props: {
    isArchive: Boolean,
  },

  data() {
    return {
      search: "",
      service: new AppointmentService(),
      modalIsVisible: false,
    };
  },

  computed: {
    ...mapGetters({
      user: "user/getUser",
      userType: "getUserType"
    }),

    isAppointmentRequest() {
      return !!(this.$route.query && this.$route.query.request);
    },

    appointments() {
      return this.service.getSortedByDateAppointments();
    }
  },

  async mounted() {
    this.loading = true;
    await this.service.getAppointmentsAll(this.isArchive);
    this.loading = false;
  },

};
</script>

<style lang="scss">
.appointmens {
  padding: 50px 40px;
  box-sizing: border-box;
  min-height: 940px;
}
.appointmens-item {
  margin-bottom: 70px;
  &__header {
    margin-bottom: 40px;
    .title {
      font-size: 28px;
      font-width: 500;
    }
  }
  &--archived {
    color: $gray;
  }
}
</style>
